import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import LinkedInJobs from '@/features/linkedin-jobs'

const searchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  filter: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/linkedin-job-list/')({
  component: LinkedInJobs,
  validateSearch: (search) => searchSchema.parse(search),
})
